<template>
  <section class="contact-content-area reveal animate-up delay-1">
    <div class="container">
      <div class="contact-grid">
        <div class="form-column">
          <div class="form-card">
            <div class="section-intro">
              <span class="tag">GET IN TOUCH</span>
              <h2>Send us a Message</h2>
              <p>
                Fill out the form below and our team will get back to you within
                24 hours.
              </p>
            </div>

            <form @submit.prevent="handleSubmit" class="contact-form">
              <div class="form-row">
                <div class="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    v-model="formData.name"
                    placeholder="Enter your name"
                  />
                  <p class="form-error" v-if="validationErrors.name">{{ validationErrors.name }}</p>
                </div>
                <div class="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    v-model="formData.email"
                    placeholder="email@example.com"
                  />
                  <p class="form-error" v-if="validationErrors.email">{{ validationErrors.email }}</p>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    v-model="formData.phone"
                    placeholder="+91 XXXX XXXXX"
                  />
                  <p class="form-error" v-if="validationErrors.phone">{{ validationErrors.phone }}</p>
                </div>
                <div class="form-group">
                  <label>Subject</label>
                  <select v-model="formData.subject">
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Property Buying">Property Buying</option>
                    <option value="Property Selling">Property Selling</option>
                    <option value="Investment">Investment Advice</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label>Message</label>
                <textarea
                  v-model="formData.message"
                  rows="6"
                  placeholder="How can we help you?"
                ></textarea>
                <p class="form-error" v-if="validationErrors.message">{{ validationErrors.message }}</p>
              </div>

              <button type="submit" class="submit-btn" :disabled="loading">
                {{ loading ? 'Sending...' : 'Send Message' }}
              </button>

              <p v-if="successMessage" class="form-success">{{ successMessage }}</p>
              <p v-if="errorMessage" class="form-error">{{ errorMessage }}</p>
            </form>
          </div>
        </div>

        <aside class="details-sidebar">
          <div class="info-card">
            <h3>Contact Information</h3>
            <div class="sidebar-links">
              <a href="tel:+917087931778" class="detail-item">
                <div class="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    ></path>
                  </svg>
                </div>
                <div class="text">
                  <small>Call Us Directly</small>
                  <p>+91-70879 31778</p>
                </div>
              </a>

              <a
                href="mailto:clientspreferredpropertyhub@gmail.com"
                class="detail-item"
              >
                <div class="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    ></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div class="text">
                  <small>Email Address</small>
                  <p class="email-text">clientspreferredpropertyhub@gmail.com</p>
                </div>
              </a>

              <a
                href="https://maps.google.com"
                target="_blank"
                class="detail-item"
              >
                <div class="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                    ></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div class="text">
                  <small>Our Office</small>
                  <p>Gillco Valley Sector-127, Kharar, Mohali</p>
                </div>
              </a>
            </div>
          </div>

          <div class="map-container">
            <iframe
              v-if="mapAllowed"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3429.5768516013346!2d76.65860737630248!3d30.72991668574495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fef93e0b2a759%3A0x633d7b819f095944!2sGillco%20Valley%2C%20Sector%20127%2C%20Kharar%2C%20Punjab%20140301!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              width="100%"
              height="280"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
            ></iframe>

            <div v-else class="map-placeholder">
              <p>
                The map is loaded from Google, which may set its own cookies.
                Allow embedded content to display it.
              </p>
              <button type="button" class="map-allow-btn" @click="allowMap">
                Load map
              </button>
              <a
                class="map-fallback-link"
                href="https://www.google.com/maps/search/Gillco+Valley+Sector-127,+Kharar,+Mohali"
                target="_blank"
                rel="noopener"
              >
                Or open in Google Maps
              </a>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { consent, saveConsent } from '@/utils/consent';

// The Google Maps embed only renders once the visitor allows embedded content.
const mapAllowed = computed(() => consent.embeds);
const allowMap = () => saveConsent({ embeds: true });

const formData = reactive({
  name: '',
  email: '',
  phone: '',
  subject: 'General Inquiry',
  message: '',
});

const validationErrors = reactive({
  name: '',
  email: '',
  phone: '',
  message: '',
});

const loading = ref(false);
const successMessage = ref('');
const errorMessage = ref('');

const validateForm = () => {
  let valid = true;

  // Reset errors
  validationErrors.name = '';
  validationErrors.email = '';
  validationErrors.phone = '';
  validationErrors.message = '';

  // Name validation
  if (!formData.name.trim()) {
    validationErrors.name = 'Name is required.';
    valid = false;
  } else if (formData.name.length < 2) {
    validationErrors.name = 'Name must be at least 2 characters.';
    valid = false;
  }

  // Email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!formData.email.trim()) {
    validationErrors.email = 'Email is required.';
    valid = false;
  } else if (!emailRegex.test(formData.email)) {
    validationErrors.email = 'Please enter a valid email address.';
    valid = false;
  }

  // Phone validation
  if (!formData.phone) {
    validationErrors.phone = 'Phone number is required.';
    valid = false;
  } else if (!/^[0-9]{7,15}$/.test(formData.phone)) {
    validationErrors.phone = 'Please enter a valid phone number.';
    valid = false;
  } else if (formData.phone.length !== 9 && formData.phone.length !== 10) {
    validationErrors.phone = 'Phone number must have 9 or 10 digits.';
    valid = false;
  }

  // Message validation
  if (!formData.message.trim()) {
    validationErrors.message = 'Message is required.';
    valid = false;
  } else if (formData.message.length < 10) {
    validationErrors.message = 'Message must be at least 10 characters.';
    valid = false;
  }

  return valid;
};

const handleSubmit = async () => {
  successMessage.value = '';
  errorMessage.value = '';

  if (!validateForm()) {
    return;
  }

  loading.value = true;

  try {
    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
    };

    const response = await fetch('https://services.mviaso.com/api/email/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      successMessage.value = 'Thank you! Your message has been sent successfully.';
      formData.name = '';
      formData.email = '';
      formData.phone = '';
      formData.subject = 'General Inquiry';
      formData.message = '';
    } else {
      errorMessage.value = 'Failed to send message. Please try again.';
    }
  } catch (error) {
    errorMessage.value = 'An error occurred. Please check your network and try again.';
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.contact-content-area {
  padding: 80px 0;
  overflow-x: hidden;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 60px;
  align-items: start;
}

/* Form Container Styling with Subtle Border */
.form-card {
  background: #ffffff;
  border: 1px solid #eaeaea;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 700;
  font-size: 0.9rem;
  color: #333;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #b91c1c;
  box-shadow: 0 0 0 3px rgba(185, 28, 28, 0.05);
}

/* Submit button */
.submit-btn {
  background: #b91c1c;
  color: white;
  padding: 16px 35px;
  border: none;
  border-radius: 4px;
  font-weight: 800;
  cursor: pointer;
  text-transform: uppercase;
  transition: all 0.3s ease;
  align-self: flex-start;
}

.submit-btn:hover:not(:disabled) {
  background: #991b1b;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(185, 28, 28, 0.2);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Validation & feedback messages */
.form-error {
  color: #dc2626;
  font-size: 0.85rem;
  margin: 2px 0 0 0;
}

.form-success {
  color: #16a34a;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

/* Section Intro */
.section-intro {
  margin-bottom: 35px;
}
.tag {
  color: #b91c1c;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 2px;
  display: block;
}
.section-intro h2 {
  font-size: 2.5rem;
  margin: 10px 0;
  color: #111;
  font-weight: 800;
}
.section-intro p {
  color: #666;
  font-size: 1.05rem;
  line-height: 1.6;
}

/* Sidebar Styling */
.info-card {
  background: #111;
  color: white;
  padding: 40px;
  border-radius: 8px;
  margin-bottom: 30px;
}
.info-card h3 {
  font-size: 1.5rem;
  margin-bottom: 35px;
  font-weight: 800;
  position: relative;
}
.info-card h3::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 40px;
  height: 2px;
  background: #b91c1c;
}
.sidebar-links {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.detail-item {
  display: flex;
  gap: 20px;
  text-decoration: none;
  color: white;
  transition: all 0.3s ease;
}
.detail-item:hover {
  transform: translateX(8px);
}
.icon-box {
  background: rgba(185, 28, 28, 0.2);
  color: #ef4444;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  flex-shrink: 0;
}
.detail-item small {
  display: block;
  color: #b91c1c;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 1px;
  margin-bottom: 4px;
}
.detail-item p {
  font-size: 1rem;
  line-height: 1.4;
  margin: 0;
  color: #e5e5e5;
}
.email-text {
  word-break: break-all;
}

.map-container {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eee;
  line-height: 0;
}

.map-placeholder {
  line-height: 1.6;
  background: #f8fafc;
  padding: 26px 22px;
  text-align: center;
}

.map-placeholder p {
  margin: 0 0 16px;
  font-size: 0.88rem;
  color: #64748b;
}

.map-allow-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  color: #fff;
  background: #b91c1c;
  border: none;
  padding: 11px 22px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.map-allow-btn:hover {
  background: #911515;
}

.map-fallback-link {
  display: block;
  margin-top: 14px;
  font-size: 0.82rem;
  color: #64748b;
  text-decoration: underline;
}

.map-fallback-link:hover {
  color: #b91c1c;
}

/* Mobile & Tablet Alignment Fixes */
@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .info-card {
    order: -1;
  }
  .contact-content-area {
    padding: 60px 0;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
  .form-card {
    padding: 25px 20px;
  }
  .section-intro h2 {
    font-size: 2rem;
  }
  .form-row {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  .submit-btn {
    width: 100%;
    align-self: center;
  }
}
</style>